var $6f40c3a58f594b58$exports = {};
const $6f40c3a58f594b58$var$heading = document.querySelector(".heading");
const $6f40c3a58f594b58$var$daysRef = document.querySelector("[data-value='days']");
const $6f40c3a58f594b58$var$hoursRef = document.querySelector("[data-value='hours']");
const $6f40c3a58f594b58$var$minutesRef = document.querySelector("[data-value='mins']");
const $6f40c3a58f594b58$var$secondsRef = document.querySelector("[data-value='secs']");
const $6f40c3a58f594b58$var$targetTime = new Date(2026, 5, 1);
const $6f40c3a58f594b58$var$id = setInterval(()=>{
    const currentTime = new Date();
    const time = $6f40c3a58f594b58$var$targetTime - currentTime;
    if (time <= 0) {
        clearInterval($6f40c3a58f594b58$var$id);
        return;
    }
    const days = Math.floor(time / 86400000);
    const hours = Math.floor(time % 86400000 / 3600000);
    const mins = Math.floor(time % 3600000 / 60000);
    const secs = Math.floor(time % 60000 / 1000);
    $6f40c3a58f594b58$var$daysRef.textContent = days;
    $6f40c3a58f594b58$var$hoursRef.textContent = hours;
    $6f40c3a58f594b58$var$minutesRef.textContent = mins;
    $6f40c3a58f594b58$var$secondsRef.textContent = secs;
}, 1000);


//# sourceMappingURL=date-hw.278fd751.js.map
